import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';

import * as examLib from 'libs/examLib';
import * as eduLib from 'libs/eduLib';
import * as normal from 'libs/normalizer';

// action types
const INITIAL_STORE = 'exam/INITIAL_STORE';
const GET_EXAM = 'exam/GET_EXAM';
const GET_EXAM_CHART = 'exam/GET_EXAM_CHART';
const GET_INFECTION_PC_LIST = 'exam/GET_INFECTION_PC_LIST';
const CHANGE_INFECTION_PC_LIST_PARAM = 'exam/CHANGE_INFECTION_PC_LIST_PARAM';
const START_EXAM = 'exam/START_EXAM';
const PREPARE_EXAM = 'exam/PREPARE_EXAM';
const CHANGE_CHART = 'exam/CHANGE_CHART';
const CHANGE_INFECTION_TARGET = 'exam/CHANGE_INFECTION_TARGET';
const CHANGE_INFECTION_PC = 'exam/CHANGE_INFECTION_PC';
const GET_INFECTION_TARGET = 'exam/GET_INFECTION_TARGET';
const GET_INFECTION_PC = 'exam/GET_INFECTION_PC';
const CHANGE_EXAM = 'exam/CHANGE_EXAM';
const CLEAR_INFECTION_TARGET = 'exam/CLEAR_INFECTION_TARGET';
const CLEAR_INFECTION_PC = 'exam/CLEAR_INFECTION_PC';
const GET_TARGET_LIST_BY_TAG = 'exam/GET_TARGET_LIST_BY_TAG';
// const GET_EXAM_LICENSE = 'exam/GET_EXAM_LICENSE';
const GET_EDU_HISTORY = 'exam/GET_EDU_HISTORY';
const CHANGE_EDU_HISTORY = 'exam/CHANGE_EDU_HISTORY';
const CLEAR_EDU_HISTORY = 'exam/CLEAR_EDU_HISTORY';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const getExam = createAction(GET_EXAM, examLib.getExam);
export const getExamChart = createAction(GET_EXAM_CHART, examLib.getExamChart);
export const getInfectionPCList = createAction(GET_INFECTION_PC_LIST, examLib.getInfectionPC);
export const changeInfectionPCListParam = createAction(CHANGE_INFECTION_PC_LIST_PARAM);
export const startExam = createAction(START_EXAM, examLib.startExam);
export const prepareExam = createAction(PREPARE_EXAM, examLib.prepareExam);
export const changeChart = createAction(CHANGE_CHART);
export const changeInfectionTarget = createAction(CHANGE_INFECTION_TARGET);
export const changeInfectionPC = createAction(CHANGE_INFECTION_PC);
export const getInfectionTarget = createAction(GET_INFECTION_TARGET, examLib.getInfectionTarget);
export const getInfectionPC = createAction(GET_INFECTION_PC, examLib.getInfectionPC);
export const changeExam = createAction(CHANGE_EXAM);
export const clearInfectionTarget = createAction(CLEAR_INFECTION_TARGET);
export const clearInfectionPC = createAction(CLEAR_INFECTION_PC);
export const getTargetListByTag = createAction(GET_TARGET_LIST_BY_TAG, examLib.getTargetListByTag);
// 훈련 실시 - 라이센스 정보 조회
// export const getExamLicense = createAction(GET_EXAM_LICENSE, examLib.getExamLicense);
// 교육 이력
export const getEduHistory = createAction(GET_EDU_HISTORY, eduLib.getEduHistoryAPI);
export const changeEduHistory = createAction(CHANGE_EDU_HISTORY);
export const clearEduHistory = createAction(CLEAR_EDU_HISTORY);

// initial state
const initialState = Map({
  data: List([]),
  startExamPrepare: Map({}),
  startExamResult: Map({
    result: -1,
    success: [],
    error: []
  }),
  // 훈련 차트 정보
  chart: Map({
    needReload: false,
    data: List([])
  }),
  // 감염 PC 탭
  infectionPCList: Map({
    param: Map({
      filter: Map({}),
      sort: [{ field: 'leakFileNo', order: 'DESC' }]
    }),
    needReload: false,
    data: List([]),
    needReload: false,

    totalPages: 0,
    totalCount: 0
  }),
  // 태그별 대상자 리스트
  targetListByTag: Map({
    needReload: false,
    data: List([]),
    param: Map({
      filter: {},
      sort: [{ field: 'examNo', order: 'DESC' }],
      offset: 0,
      limit: 5
    }),
    page: 1,
    totalPage: 0,
    totalTarget: 0
  }),
  // [결과보기 상세] 감염 대상
  infectionTarget: Map({
    needReload: false,
    isOpen: List([]),
    data: List([]),
    param: Map({
      filter: {},
      sort: [{ field: 'examNo', order: 'DESC' }],
      offset: 0,
      limit: 5
    }),
    page: 1,
    totalPage: 0,
    totalTarget: 0
  }),
  // [결과보기 상세] 감염 PC
  infectionPC: Map({
    needReload: false,
    data: List([]),
    param: Map({
      filter: {},
      sort: [{ field: 'examNo', order: 'DESC' }],
      offset: 0,
      limit: 5
    }),
    page: 1,
    totalPage: 0,
    totalPC: 0
  }),
  // [결과보기 상세] 교육 이력
  eduList: Map({
    needReload: false,
    data: List([]),
    param: Map({
      filter: {},
      sort: [{ field: 'eduNo', order: 'DESC' }],
      offset: 0,
      limit: 5
    }),
    page: 1,
    totalPages: 0,
    totalEdu: 0
  })
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    // 훈련 조회
    ...pender({
      type: GET_EXAM,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        return state.set('data', fromJS(normal.examData(list)));
      },
      onFailure: (state, action) => {
        return state.set('data', Map({}));
      }
    }),
    // 감염 PC 탭
    ...pender({
      type: GET_INFECTION_PC_LIST,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = list.length > 0 ? list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);

        state = state
          .setIn(['infectionPCList', 'needReload'], false)
          .setIn(['infectionPCList', 'totalPages'], totalPages)
          .setIn(['infectionPCList', 'totalCount'], totalCount);

        return state.setIn(['infectionPCList', 'data'], fromJS(list));
      },
      onFailure: (state, action) => {
        return state.setIn(['infectionPCList', 'data'], List([]));
      }
    }),
    // 훈련 차트 조회
    ...pender({
      type: GET_EXAM_CHART,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        state = state.setIn(['chart', 'needReload'], false);

        return state.setIn(['chart', 'data'], fromJS(list));
      },
      onFailure: (state, action) => {
        return state.setIn(['chart', 'data'], Map({}));
      }
    }),
    // 훈련 준비 사항 조회
    ...pender({
      type: PREPARE_EXAM,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const data = list && Array.isArray(list) && list.length > 0 ? list[0] : {};

        return state.set('startExamPrepare', fromJS(data));
      },
      onFailure: (state, action) => {}
    }),
    // 훈련 실행
    ...pender({
      type: START_EXAM,
      onSuccess: (state, action) => {
        const { data } = action.payload;

        return normal.payloadDataSaver(state, 'startExamResult', data);
      },
      onFailure: (state, action) => {
        //
      }
    }),
    // [결과보기 상세] 감염 대상
    ...pender({
      type: GET_INFECTION_TARGET,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { refresh, offset, limit } = action.payload.config.params;

        state = state.setIn(['infectionTarget', 'needReload'], false);

        let curPage = 1;
        let curArray = [];
        if (list.length > 0) {
          if (refresh) {
            state = state
              .setIn(['infectionTarget', 'totalPage'], Math.ceil(list[0].rnum / limit))
              .setIn(['infectionTarget', 'totalTarget'], list[0].rnum);

            curArray = list;
          } else {
            curPage = state.getIn(['infectionTarget', 'page']) + 1;
            curArray = state
              .getIn(['infectionTarget', 'data'])
              .toJS()
              .concat(list);
          }
        } else {
          state = state.setIn(['infectionTarget', 'totalPage'], 0).setIn(['infectionTarget', 'totalTarget'], 0);
        }

        return state
          .setIn(['infectionTarget', 'page'], curPage)
          .setIn(['infectionTarget', 'isOpen'], List([]))
          .setIn(['infectionTarget', 'data'], fromJS(curArray));
      },
      onFailure: (state, action) => {
        return state.setIn(['infectionTarget', 'data'], List([]));
      }
    }),
    // [결과보기 상세] 감염 PC
    ...pender({
      type: GET_INFECTION_PC,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { refresh, which, offset, limit } = action.payload.config.params;

        state = state.setIn(['infectionPC', 'needReload'], false);

        let curPage = 1;
        let curArray = [];
        if (list.length > 0) {
          if (refresh) {
            state = state
              .setIn(['infectionPC', 'totalPage'], Math.ceil(list[0].rnum / limit))
              .setIn(['infectionPC', 'totalPC'], list[0].rnum);

            curArray = list;
          } else {
            curPage = state.getIn(['infectionPC', 'page']) + 1;
            curArray = state
              .getIn(['infectionPC', 'data'])
              .toJS()
              .concat(list);
          }
        } else {
          state = state.setIn(['infectionPC', 'totalPage'], 0).setIn(['infectionPC', 'totalPC'], 0);
        }

        return state.setIn(['infectionPC', 'page'], curPage).setIn(['infectionPC', 'data'], fromJS(curArray));
      },
      onFailure: (state, action) => {
        return state.setIn(['infectionPC', 'data'], List([]));
      }
    }),
    // 태그별 대상자 리스트 조회
    ...pender({
      type: GET_TARGET_LIST_BY_TAG,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { refresh, offset, limit } = action.payload.config.params;

        state = state.setIn(['targetListByTag', 'needReload'], false);

        let curPage = 1;
        let curArray = [];
        if (list.length > 0) {
          if (refresh) {
            state = state
              .setIn(['targetListByTag', 'totalPages'], Math.ceil(list[0].rnum / limit))
              .setIn(['targetListByTag', 'totalTarget'], list[0].rnum);

            curArray = list;
          } else {
            curPage = state.getIn(['targetListByTag', 'page']) + 1;
            curArray = state
              .getIn(['targetListByTag', 'data'])
              .toJS()
              .concat(list);
          }
        } else {
          state = state.setIn(['targetListByTag', 'totalPage'], 0).setIn(['targetListByTag', 'totalTarget'], 0);
        }

        return state.setIn(['targetListByTag', 'page'], curPage).setIn(['targetListByTag', 'data'], fromJS(curArray));
      },
      onFailure: (state, action) => {
        return state.setIn(['targetListByTag', 'data'], List([]));
      }
    }),
    // 훈련별 교육 이력
    ...pender({
      type: GET_EDU_HISTORY,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { refresh, which, offset, limit } = action.payload.config.params;

        state = state.setIn(['eduList', 'needReload'], false);

        let curPage = 1;
        let curArray = [];
        if (list.length > 0) {
          if (refresh) {
            state = state
              .setIn(['eduList', 'totalPages'], Math.ceil(list[0].rnum / limit))
              .setIn(['eduList', 'totalEdu'], list[0].rnum);

            curArray = list;
          } else {
            curPage = state.getIn(['eduList', 'page']) + 1;
            curArray = state
              .getIn(['eduList', 'data'])
              .toJS()
              .concat(list);
          }
        } else {
          state = state.setIn(['eduList', 'totalPages'], 0).setIn(['eduList', 'totalEdu'], 0);
        }

        return state.setIn(['eduList', 'page'], curPage).setIn(['eduList', 'data'], fromJS(curArray));
      },
      onFailure: (state, action) => {
        return state.setIn(['eduList', 'data'], List([]));
      }
    }),
    [CHANGE_EXAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.set(name, value);
    },
    [CHANGE_CHART]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['chart', name], value);
    },
    [CHANGE_INFECTION_TARGET]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['infectionTarget', name], value);
    },
    [CHANGE_INFECTION_PC]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['infectionPC', name], value);
    },
    [CHANGE_INFECTION_PC_LIST_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['infectionPCList', 'param', name], value);
    },
    [CHANGE_EDU_HISTORY]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['eduList', name], value);
    },

    [CLEAR_INFECTION_TARGET]: (state, action) => {
      return state.set('infectionTarget', initialState.get('infectionTarget'));
    },
    [CLEAR_INFECTION_PC]: (state, action) => {
      return state.set('infectionPC', initialState.get('infectionPC'));
    },
    [CLEAR_EDU_HISTORY]: (state, action) => {
      return state.set('eduList', initialState.get('eduList'));
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/exam.js